module.exports = __webpack_public_path__ + "static/media/Produce-Dept.fc59a5e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Produce-Dept.jpg
// module id = 475
// module chunks = 0